angular
  .module('cfn')
  .controller(
    'amazoneMachineSettingsPopupController',
    amazoneMachineSettingsPopupController
  );

amazoneMachineSettingsPopupController.$inject = [
  '$scope',
  '$http',
  'dialog',
  'scope',
  'i18nFilter',
  'amazoneMachineService',
  'bookingRules',
  'unitConverter'
];
function amazoneMachineSettingsPopupController(
  $scope,
  $http,
  dialog,
  scope,
  i18nFilter,
  amazoneMachineService,
  bookingRules,
  unitConverter
) {
  var controller = this;
  $scope.controller = $scope.partnerAmazoneMachineSettingsPopupController = controller;
  controller.close = function() {
    dialog.close({ action: 'cancelled' });
  };

  controller.nextAction = null;
  $scope.data = {};
  $scope.reportDate = new Date();
  var dataStep0 = null;

  controller.ok = function() {
    $('#ifForm').validationEngine({ showOneMessage: true });
    if ($('#ifForm').validationEngine('validate')) {
      $('#ifForm').validationEngine('detach');
      controller.nextAction();
    }
  };

  controller.doService = function() {
    app.showLoader();
    amazoneMachineService.getData($scope.data).then(function(response) {
      dataStep0 = $scope.data;
      $scope.data = amazoneMachineService.reduce(response.data);

      var fieldSetting = $scope.data.settings[0];
      var setting = fieldSetting.settings.settings[0];
      if (angular.isDefined(setting.diskSetting)) {
        $scope.ZamStyleDisk = { display: 'inline', float: 'left' };
        $scope.ZatsStyleDisk = { display: 'none' };
      } else {
        $scope.ZamStyleDisk = { display: 'none' };
        $scope.ZatsStyleDisk = { display: 'inline', float: 'left' };
      }
      if (angular.isDefined(setting.limiterSetting)) {
        $scope.StyleLimiter = { display: 'inline', float: 'left' };
      } else {
        $scope.StyleLimiter = { display: 'none' };
      }
      if (angular.isDefined(setting.hydroSetting)) {
        $scope.StyleHydro = { display: 'inline', float: 'left' };
      } else {
        $scope.StyleHydro = { display: 'none' };
      }
      if (angular.isDefined(setting.tsSetting)) {
        $scope.StyleTs = { display: 'inline', float: 'left' };
      } else {
        $scope.StyleTs = { display: 'none' };
      }
      if (
        angular.isDefined(
          fieldSetting.settings.sprdTableQuantityReductEntries
        ) &&
        fieldSetting.settings.sprdTableQuantityReductEntries.length > 0
      ) {
        $scope.StyleSprdTable = { display: 'inline', float: 'left' };
      } else {
        $scope.StyleSprdTable = { display: 'none' };
      }

      app.hideLoader();
      controller.nextAction = null;
    });
  };

  controller.saveClick = function() {
    $scope.data.machine = null;
    $scope.data.fertilizer = null;
    scope.details.notesJson = JSON.stringify($scope.data); // save to notesJson
    $scope.state.saved = true;
    controller.close();
  };

  controller.deleteClick = function() {
    scope.details.notesJson = null;
    $scope.state.saved = false;
    $scope.data = {};
    controller.init();
    controller.initServer();
  };

  controller.init = function() {
    $scope.data.stepInput = null;
    controller.loaded = false;
    controller.msg = i18nFilter('fe.partner.amazone.loading', 'laden...');
    controller.nextAction = controller.doService;
  };

  $scope.state = {
    saved: scope.directData || scope.details.notesJson,
    display: scope.directData,
    readOnly: scope.directData
  };

  // ========== button functions start ==========

  // Speichern       controller.loaded && !data.stepInput && (!state.saved)                        controller.saveClick()
  // Zurücksetzten   controller.loaded && !data.stepInput && (state.saved) &&(!state.readOnly)     controller.deleteClick()
  // Schliessen      controller.loaded && !data.stepInput                                          controller.close()
  // Weiter          controller.loaded && controller.nextAction!=null                              controller.ok()

  controller.btnNextLabel = function() {
    if (controller.loaded && !$scope.data.stepInput && !$scope.state.saved) {
      return i18nFilter('fe.common.save', 'Speichern');
    } else if (
      controller.loaded &&
      !$scope.data.stepInput &&
      $scope.state.saved
    ) {
      return i18nFilter('fe.common.reset', 'Zurücksetzen');
    } else if (controller.loaded && !$scope.data.stepInput) {
      return i18nFilter('fe.common.close', 'Schliessen');
    }
    return i18nFilter('fe.common.next', 'Weiter');
  };

  controller.btnNextAction = function() {
    if (controller.loaded && !$scope.data.stepInput && !$scope.state.saved) {
      controller.saveClick();
    } else if (
      controller.loaded &&
      !$scope.data.stepInput &&
      $scope.state.saved
    ) {
      if (!$scope.state.readOnly) controller.deleteClick();
    } else if (controller.loaded && !$scope.data.stepInput) {
      controller.close();
    } else {
      controller.ok();
    }
  };

  controller.btnNextDisabled = function() {
    if (!controller.loaded) {
      return true;
    } else if (controller.nextAction) {
      return false;
    } else if ($scope.state && $scope.state.saved && $scope.state.readOnly) {
      return true;
    }
    return $scope.data.stepInput;
  };

  controller.btnPrevAction = function() {
    $scope.data = dataStep0;
    controller.nextAction = controller.doService;
  };

  controller.btnPrevDisabled = function() {
    return !(
      controller.loaded &&
      !$scope.data.stepInput &&
      !$scope.state.saved
    );
  };

  controller.btnPrintEnabled = function() {
    return controller.loaded && !$scope.data.stepInput;
  };

  controller.btnCancelAction = function() {
    dialog.close({
      action: 'cancelled'
    });
  };

  controller.btnCancelDisabled = function() {
    return false;
  };

  /**
   * Method truncates the given value after 70 chars.
   */
  controller.truncFieldName = function(value) {
    if (value === null || value === undefined) return 0;
    if (value.length > 70) return value.substring(0, 70) + '...';
    else return value;
  };

  controller.print = function() {
    ang.callAfter(function() {
      ang.callAfter(function() {
        $('#printFrame').attr('src', 'print.html');

        var html = $('.reportingContent').html();

        $('#printFrame').load(function() {
          $('#printFrame')
            .contents()
            .find('body')
            .html(html);
          $('#printFrame')[0].contentWindow.focus(); // for ie we have to focus the iframe before
          setTimeout(function() {
            $('#printFrame')[0].contentWindow.print();
          }, 1000);
        });
      });
    }, $scope);
  };

  // ========== button functions end ==========

  var validated = true;
  var carrierId = null;
  var proportions = [];
  if (!$scope.state.readOnly) {
    controller.init();
    for (var i in scope.details.machineList) {
      var machine = scope.details.machineList[i];
      console.debug('possible carrier', machine);
      if (machine.resource.type_TRACTOR == true) {
        carrierId = machine.resource.id;
        break;
      }
    }
    bookingRules.elements.supply.onSave(scope.details);

    // Nur Proportions aus Mittelbuchung (supplyType === null)
    var supplyProportions = scope.details.supplyProportions.filter(function(
      supply
    ) {
      return supply.supplyType === null;
    });

    if (scope.details.fieldList.length == 0) {
      validated = false;
      controller.nextAction = null;
      controller.loaded = false;
      controller.msg = i18nFilter(
        'fe.partner.amazone.noField',
        'Bitte mindestens einen Schlag auswählen.'
      );
    } else {
      if (
        angular.isDefined(scope.details.supplies[0].unit) &&
        angular.isDefined(enums.UnitsCapacityEnum)
      ) {
        $scope.supplyUnit =
          enums.UnitsCapacityEnum[scope.details.supplies[0].unit];
      } else {
        $scope.supplyUnit = 'kg';
      }

      for (var i in supplyProportions) {
        var prop = supplyProportions[i];

        if (prop.amountPerArea) {
          // rechnet von beliebigem Mass in KG um. Amazone kann nur KG. Nur gültig für Gewichtseinheiten !
          // lt. Requirement-Engineer nicht für Flüssigkeiten und Stückeinheiten
          var convertAmount = unitConverter.convertCapacity(
            scope.details.supplies[0].unit,
            'MASS_KG',
            prop.amountPerArea
          );

          proportions.push({
            assetId: prop.assetId,
            amountPerArea: convertAmount
          });
        } else {
          validated = false;
          controller.nextAction = null;
          controller.loaded = false;
          controller.msg = i18nFilter(
            'fe.partner.amazone.noQuantity',
            'Die Menge pro Schlag wurde nicht überall gefüllt.'
          );
        }
      }
    }
  }
  // find carrier id ( tractor)

  if (scope.directData) {
    $scope.data = scope.directData;
    controller.nextAction = null;
    controller.loaded = true;
  } else {
    if (scope.details.notesJson) {
      try {
        $scope.data = jQuery.parseJSON(scope.details.notesJson);
      } catch (err) {
        $scope.data = {};
        //scope.details.notesJson = null;
      }
      controller.nextAction = null;
      controller.loaded = true;
    }
  }

  function isResponseValid(rsp) {
    return rsp && rsp.proposal;
  }

  controller.initServer = function() {
    $http
      .post('/365FarmNet/rest/partner/amazone/init', {
        machineId: scope.object.id,
        fertlizerId: scope.details.fertilizerId,
        carrierId: scope.object.id, //carrierId, ursprünglich war der gedanke, dass eine zugmaschine verwendet werden muss um die fahrtgeschwindigkeit zu verwenden
        proportions: proportions
      })
      .then(function(response) {
        var data = response.data;
        // if validation failed in previous step, ignore response
        if (validated) {
          if (data && !data.errorMsg) {
            $scope.data = data;
            controller.loaded = true;
            if (!isResponseValid(data)) {
              controller.nextAction = null; // Hide the next button, if response is not valid.
            }
          } else {
            controller.loaded = false;
            controller.msg = i18nFilter(data.errorMsg, data.errorMsg);
          }
        }
      });
  };
  // init directly if not saved
  if (!$scope.state.saved) {
    controller.initServer();
  }
  return this;
}
